import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { SubscriptionType } from "../../types/Student";
import { PdfPreviewContent } from "../PdfPreviewContent";
import { CreateStudentDebtReferenceResultType, CreateStudentDebtReferenceType, ReferenceReportType } from "../../types/Finance";
import { BASE_URL, UPLOAD_IMAGES } from "../../utils/constants";
import { useIES } from "../../hooks/useIES";

export const References = () => {
  const { IES, isLoading } = useIES();
  const currentDate = new Date().toLocaleDateString("pt-PT");
  const userData = useSelector((state: RootState) => state.login.userData)

  const referencesLS = localStorage.getItem("studentDebtReferencesData");
  const preloadedReferenceData: ReferenceReportType = referencesLS ? JSON.parse(referencesLS) : undefined;

  const referenceDataFromState = useSelector((state: RootState) => state.reference);

  const referenceData = preloadedReferenceData || referenceDataFromState;

  const createStudentDebtReferencesData = referenceData?.data;
  const references = referenceData?.references;
  console.log({ referenceData });

  useEffect(() => {
    localStorage.removeItem("studentDebtReferencesData");
    localStorage.removeItem("pdfPreviewTypeData_REFS");
  }, []);

  return (
    <PdfPreviewContent>
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <img
          src={`${IES.LOGO}`}
          alt="Logo"
          style={{ width: "100px", height: "auto" }}
        />
      </div>
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <h1 style={{ fontSize: "14px", marginBottom: "5px" }}>
          {IES.NAME}- REP. ACADÉMICA
        </h1>
        <h2
          style={{
            fontSize: "12px",
            borderTop: "1px solid #000",
            borderBottom: "1px solid #000",
            padding: "2px 0",
            margin: "5px 0",
          }}
        >
          DIRECÇÃO DE REGISTO ACADÉMICO
        </h2>
        <h3
          style={{
            fontSize: "12px",
            border: "1px solid #000",
            padding: "2px 0",
            margin: "5px 0",
          }}
        >
          REFERÊNCIAS DE PAGAMENTO
        </h3>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "15px",
          color: "blue",
        }}
      >
        <span>Original</span>
        <span>Emitido em: {currentDate}</span>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
        }}
      >
        <span>Dados do Estudante:</span>
        <span>Ano Lectivo: {createStudentDebtReferencesData?.year}/{createStudentDebtReferencesData?.semester} </span>
      </div>
      <div style={{ marginBottom: "15px", borderBottom: "1px solid #000", borderTop: "1px solid #000" }}>
        <div style={{ marginTop: "5px" }}>
          <p>Estudante: {createStudentDebtReferencesData?.fullname} Nº: {createStudentDebtReferencesData?.studentCode}</p>
          {/* <p>Curso: {subscriptionData?.course}</p> */}
          {/* <p>Delegação: {enrollmentData.enrollment?.departament} Campus: {enrollmentData?.enrollment?.faculty}</p> */}
        </div>
      </div>
      {/* Refs. */}
      <div style={{ marginBottom: "15px" }}>
        <div style={{ marginBottom: "5px", textDecoration: "underline" }}>
          Refs:
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>Ord.</th>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>Mês</th>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>Referencia</th>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>Valor </th>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>Entidade</th>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>Validade</th>
            </tr>
          </thead>
          <tbody>
            {references?.map((reference, index) => (
              <tr key={`s-${index}`}>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {index + 1}
                </td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {reference.month}
                </td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {reference.referenceCode}
                </td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {reference.amount.toFixed(2)}
                </td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {reference.bankEntity}
                </td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {reference?.dueDate ? new Date(reference.dueDate).toLocaleDateString("pt-PT") : "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <div
          style={{
            width: "300px",
            borderTop: "1px solid #000",
            margin: "0 auto 5px",
          }}
        ></div>
        <span>{userData?.Fullname} | {userData?.Role}</span>
      </div>
      <div style={{ fontSize: "10px", color: "blue", textAlign: "center" }}>
        <p>Impresso no dia {currentDate}</p>
      </div>
    </PdfPreviewContent>
  );
};
